import { ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import React from 'react';
import { bool, func, string } from 'prop-types';
import Avatar from './styles/Avatar';
import ItemButton from './styles/ItemButton';

function GeoZoneListItem({ name = '', selected = false, onClick }) {
  return (
    <ListItem>
      <ItemButton selected={selected} onClick={onClick}>
        <ListItemAvatar>
          <Avatar selected={selected}>
            <InsertPhotoIcon />
          </Avatar>
        </ListItemAvatar>

        <ListItemText primary={name} />
      </ItemButton>
    </ListItem>
  );
}

GeoZoneListItem.propTypes = {
  // eslint-disable-next-line react/require-default-props
  name: string,
  // eslint-disable-next-line react/require-default-props
  selected: bool,
  // eslint-disable-next-line react/require-default-props
  onClick: func,
};

export default GeoZoneListItem;
